import types from './types';
import { sagas, actions } from './actions';
import reducer, { selectors } from './reducer';

export default reducer;

export {
    types as exampleTypes,
    sagas as exampleSagas,
    actions as exampleActions,
    selectors as exampleSelectors
};
